import React, { useContext, useState } from 'react';
import { LanguageContext } from '../App';
import { translations } from '../i18n/translations';
import { theme } from '../config/theme';

function SearchBar({ onSearch, onClear }) {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [query, setQuery] = useState('');

  const handleSearch = () => { if (query.trim()) onSearch(query.trim()); };
  const handleClear = () => { setQuery(''); onClear(); };
  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSearch(); };

  return (
    <div style={styles.container}>
      <input
        type="text" value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t.search}
        style={styles.input}
      />
      <button onClick={handleSearch} style={styles.searchBtn}>
        {t.searchButton}
      </button>
      {query && (
        <button onClick={handleClear} style={styles.clearBtn}>
          {t.clearSearch}
        </button>
      )}
    </div>
  );
}

const styles = {
  container: { display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '20px' },
  input: {
    flex: 1, padding: '8px 14px',
    backgroundColor: theme.colors.bgCard,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px', fontSize: '13px',
    color: theme.colors.textPrimary, outline: 'none',
  },
  searchBtn: {
    backgroundColor: theme.colors.white, color: theme.colors.textDark,
    border: 'none', borderRadius: '4px', padding: '8px 16px',
    cursor: 'pointer', fontSize: '12px', fontWeight: '600',
  },
  clearBtn: {
    backgroundColor: 'transparent', color: theme.colors.textSecondary,
    border: `1px solid ${theme.colors.border}`, borderRadius: '4px',
    padding: '8px 12px', cursor: 'pointer', fontSize: '12px',
  },
};

export default SearchBar;